<template>
  <div class="hb-upload-document-dialog">
    <!-- 编辑选校 -->
    <el-dialog :visible.sync="openDialog" width="80%" :title="content.title" center destroy-on-close>
      <div class="demo-image__placeholder">
        <div class="block" style="text-align: center">
<!--          <span class="demonstration">默认</span>-->
          <el-image :src="src" style="width: 95%;margin: 0 auto"></el-image>
        </div>
      </div>

      <div  v-if="sing_doucment">
        <div class="demo-image__placeholder" style="width: 95%;margin: 0 auto">
          <div class="block">
            <h5 style="font-weight: 500;margin-top: 20px">签字：</h5>
          </div>

          <div class="block" style="text-align: center;display: block;">
            <div style="display: block;float: left;width: 100px;margin-right: 20px" v-for="item in fileList">
              <el-image :src="item.url" style="width: 95%;margin: 0 auto" :preview-src-list="[item.url]"></el-image>
              <span class="demonstration" v-if="item.name == 'cn'">中文</span>
              <span class="demonstration" v-if="item.name == 'en'">英文</span>
            </div>
          </div>
          <div style="clear: both"></div>

<!--          <div class="block">-->
<!--            <h5 style="font-weight: 500;margin-top: 20px">签名附件：</h5>-->
<!--            <p > <el-link type="primary"> 附件1 ></el-link> </p>-->
<!--            <p > <el-link type="primary"> 附件2 ></el-link> </p>-->
<!--            <p > <el-link type="primary"> 附件3 ></el-link> </p>-->
<!--          </div>-->
        </div>
        <div class="block" style="text-align: center;margin-top: 20px">
          <el-button type="primary" @click="openDialog = false">确 定</el-button>
        </div>

      </div>
      <div v-if="!sing_doucment">
        <div class="demo-image__placeholder">
          <div class="block" style="text-align: center">
            <el-image :src="qr_code" style="width: 300px;margin-top: 30px"></el-image>
            <p class="demonstration">使用手机扫码签字</p>
          </div>
          <div class="block" style="text-align: center;margin-top: 20px">
            <el-button @click="openDialog = false">取 消</el-button>
            <el-button type="primary" @click="lookScores">已签字，刷新</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {check_is_addsing_document} from "../../../api/mycenter_studyabroad";

export default {
  data () {
    return {
      sing_doucment: false,
      qr_code: 'https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E314985040747026.png',
      src: 'https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E314985510445591.png',
      document_status: false,
      submitLoading: false,
      fileList: [],
      openDialog: false,
      loading: false,
      content: {
        data: '',
        type: '',
        title: '',
        name: '',
        con: '',
        operate: '',
        document_status: '',
        id: ''
      }
    }
  },
  created () {

  },
  methods: {
    sendItem(content) {
      this.fileList = [];

      console.log('11', content)
      if(content.operate == 'add') {
        this.sing_doucment = false
      }
      if(content.operate == 'show') {
        this.sing_doucment = true
        content.data.forEach((item) => {
          this.fileList.push({'url':item.url,'name':item.type_name})
        })
      }
      this.content = content
      this.openDialog = true
    },
    lookScores() {
      check_is_addsing_document().then(response => {
        console.log(response)
        if(response.data.list.length){
          response.data.list.forEach((item) => {
            this.fileList.push({'url':item.url,'name':item.type_name})
          })
          this.sing_doucment = true
        }else {
          this.$message.error("未检出到上传图片，请确定是否上传文件");
        }
      })
    },


  }
}
</script>
<style lang="scss" scoped>
.hb-upload-document-dialog {
  .upload-demo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    .el-upload-list {
      max-width: 100%;
    }
    .control-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      .tip-text {
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/add_sing_document.vue